import { Navigate } from "react-router-dom"
import { useActivation } from "@/lib/activation-context"

export function HomeScreen() {
  const { currentStep, isHydrating } = useActivation()
  if (isHydrating) return null

  const target = currentStep > 5 ? "/dashboard" : `/activation/step/${currentStep}`
  return <Navigate to={target} replace />
}
